import { useContext, useEffect, useState } from 'react'
import { LocalizationContext } from 'src/consumer/context/LocalizationContext'
import { commonHeadersWeb } from 'src/consumer/services'
import { PatientHomepageTodaysBookingSection, PatientHomepageWelcomeSection } from './components'

export default function PatientHomeWrapperForWebview() {
  const { refreshLocaleData } = useContext(LocalizationContext)

  const [chosenPatientId, setChosenPatientId] = useState(
    sessionStorage.getItem('chosenPatientId') || null,
  )

  useEffect(() => {
    try {
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.iosBridge
      ) {
        window.webkit.messageHandlers.iosBridge.postMessage({ method: 'getUserToken' })
        window.webkit.messageHandlers.iosBridge.postMessage({ method: 'setAumhumRequestHeaders' })
      }
    } catch (error) {
      console.error('Got error in calling iOS interface method:', error)
    }

    // Exposing setting methods for iOS to use
    window.setToken = function (token) {
      try {
        console.debug(token)
        localStorage.setItem('token', token)
      } catch (error) {
        console.error('Error setting token:', error)
      }
    }

    window.setAumhumRequestHeaders = function (headers) {
      try {
        console.log('headers from IOS is ' + headers)
        replaceHeadersAndCallSetupAPI(headers)
      } catch (error) {
        console.error('Error setting Headers:', error)
      }
    }

    // Call Android interface methods
    if (window.Android && typeof window.Android.getUserToken === 'function') {
      const tokenFromAndroid = window.Android.getUserToken()
      console.log('user token from android is  ' + tokenFromAndroid)
      localStorage.setItem('token', tokenFromAndroid)
    }

    if (window.Android && typeof window.Android.setAumhumRequestHeaders === 'function') {
      const headers = window.Android.setAumhumRequestHeaders()
      console.log('headers from token from android  ' + headers)
      replaceHeadersAndCallSetupAPI(headers)
    }

    function replaceHeadersAndCallSetupAPI(headers) {
      const parsedHeaders = JSON.parse(headers)

      localStorage.setItem('countryCode', parsedHeaders['ef-user-country-code'])
      localStorage.setItem('languageCode', parsedHeaders['ef-app-language'])
      sessionStorage.setItem('languageCode', parsedHeaders['ef-app-language'])

      for (let key of Object.keys(parsedHeaders)) {
        commonHeadersWeb[key] = parsedHeaders[key] || commonHeadersWeb[key]
      }

      refreshLocaleData()
    }
  }, [])

  return (
    <div style={{ paddingTop: '64px' }}>
      <div>
        <PatientHomepageWelcomeSection
          chosenPatientId={chosenPatientId}
          setChosenPatientId={setChosenPatientId}
        />
        <PatientHomepageTodaysBookingSection
          chosenPatientId={chosenPatientId}
          setChosenPatientId={setChosenPatientId}
        />
      </div>
    </div>
  )
}
